import { type ValueOf } from '@dni-types/utilities/value-of'

export const STM_AUTH_ERROR_KIND = {
  MALL_CAMPAIGNS_UNAVAILABLE: 'mall_campaigns_unavailable',
  NO_AVAILABLE_BRANDS: 'no_available_brands',
  DEFAULT: 'default',
} as const

export type StmAuthErrorKind = ValueOf<typeof STM_AUTH_ERROR_KIND>

export const STM_AUTH_ERROR_MESSAGE: Record<StmAuthErrorKind, string> = {
  [STM_AUTH_ERROR_KIND.MALL_CAMPAIGNS_UNAVAILABLE]: '載入站台資料失敗，請稍後再試或洽負責業務',
  [STM_AUTH_ERROR_KIND.NO_AVAILABLE_BRANDS]: '目前站台尚未開放，請洽負責業務',
  [STM_AUTH_ERROR_KIND.DEFAULT]: '權限不足，無法登入',
}
